"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const m = require("mithril");
function makeOption1(name) {
    return m('option', name);
}
function makeOption2(name) {
    return m(`option[value:"${name}"]`, name);
}
function makeDropdown(options, id) {
    const children = options.map(name => makeOption1(name));
    const top = m('select', { id: id }, children);
    return top;
}
exports.makeDropdown = makeDropdown;



//////////////////
// WEBPACK FOOTER
// ./gui/mithril-helper.ts
// module id = 11
// module chunks = 0